// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  height: 100vh;
  --background: transparent;
}

.game-results {
  -webkit-user-select: none;
          user-select: none;
}
.game-results .title {
  margin-top: 0.3rem;
  color: #fff;
  font-size: 1.167rem;
  font-weight: bold;
  margin-bottom: 0.792rem;
}
.game-results .rowAvatars {
  width: 39rem;
  margin: auto;
}
.game-results .rowAvatars .avatar.active {
  border: 0.083rem solid #FBDB55;
  border-radius: 0.667rem;
}
.game-results .rowAvatars .avatar.active .box1 .image1 {
  display: block;
}
.game-results .rowAvatars .avatar.active .box1 .platform-glow-copy {
  display: block;
}
.game-results .rowAvatars .avatar.active .box1 .triangle-copy {
  display: block;
}
.game-results .rowAvatars .avatar.active .finalScoreText {
  display: block;
}
.game-results .rowAvatars .avatar.active .finalScoreNum {
  padding-top: 0;
  margin-top: -0.2rem;
}
.game-results .rowAvatars .avatar.active .badges {
  display: block;
}
.game-results .rowAvatars .avatar {
  min-width: 6.771rem;
  height: 13.1rem;
  margin: 1rem auto 0.958rem auto;
  position: relative;
}
.game-results .rowAvatars .avatar .icons .section {
  position: absolute;
  top: 0;
  transform: translateY(-50%);
  display: flex;
  width: 100%;
  justify-content: center;
  margin-left: -0.2rem;
  gap: 0.2rem;
}
.game-results .rowAvatars .avatar .icons .section .border-icon {
  width: 1rem;
  height: 1rem;
  border-radius: 1.458rem;
  background-color: #F5DB6C !important;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
}
.game-results .rowAvatars .avatar .icons .section .border-icon .icon {
  padding: 0.1rem;
  pointer-events: none;
}
.game-results .rowAvatars .avatar .playerName {
  margin-top: 0.4rem;
  text-align: center;
  font-size: 0.883rem;
  font-weight: bold;
  color: white;
}
.game-results .rowAvatars .avatar .box1 {
  position: relative;
  top: 2.8rem;
  left: 50%;
  transform: translateX(-43%);
  margin-top: 0.208rem;
  height: 7.384rem;
  width: 6.771rem;
}
.game-results .rowAvatars .avatar .box1 .image1 {
  position: relative;
  top: -3rem;
  left: -1.992rem;
  height: 6.952rem;
  width: 9.426rem;
  display: none;
  pointer-events: none;
}
.game-results .rowAvatars .avatar .box1 .image2 {
  position: absolute;
  top: -3.1rem;
  left: 0.2rem;
  height: 6.384rem;
  width: 4.75rem;
  pointer-events: none;
  z-index: 5;
}
.game-results .rowAvatars .avatar .box1 .platform-glow {
  position: absolute;
  top: -1.026rem;
  left: 1.15rem;
  height: 4.036rem;
  width: 3.458rem;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.4) 100%);
}
.game-results .rowAvatars .avatar .box1 .triangle {
  position: absolute;
  top: 3.02rem;
  left: 1.15rem;
  border: 1.72rem solid transparent;
  border-top: 1.05rem solid rgba(255, 255, 255, 0.4);
}
.game-results .rowAvatars .avatar .box1 .platform-glow-copy {
  position: absolute;
  top: 0.5rem;
  left: 1.6rem;
  height: 2.458rem;
  width: 2.555rem;
  background: linear-gradient(180deg, rgba(249, 236, 177, 0) 0%, rgba(255, 255, 255, 0.55) 100%);
  display: none;
}
.game-results .rowAvatars .avatar .box1 .triangle-copy {
  position: absolute;
  top: 2.96rem;
  left: 1.55rem;
  border: 1.3rem solid transparent;
  border-top: 0.7rem solid rgba(255, 255, 255, 0.55);
  display: none;
}
.game-results .rowAvatars .avatar .finalScoreText {
  text-align: center;
  margin-top: -0.6rem;
  white-space: nowrap;
  font-size: 0.967rem;
  color: white;
  display: none;
}
.game-results .rowAvatars .avatar .finalScoreNum {
  text-align: center;
  font-weight: bold;
  color: #F5DB6C;
  height: 1.792rem;
}
.game-results .rowAvatars .avatar .badges {
  position: absolute;
  top: 98%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 1rem;
  display: none;
}
.game-results .rowAvatars .avatar .badges .game-bar {
  width: 10.333rem;
  height: 1.708rem;
  background: var(--color-light-blue);
  border-radius: 5rem;
  display: flex;
  margin-top: -1.7rem;
  margin-left: auto;
  margin-right: auto;
}
.game-results .rowAvatars .avatar .badges .game-bar .bar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.58325rem;
  border-right: 0.042rem solid rgba(0, 0, 0, 0.32);
  gap: 0.167rem;
  text-decoration: none;
}
.game-results .rowAvatars .avatar .badges .game-bar .bar .icon {
  width: 1.083rem;
  height: 1rem;
  pointer-events: none;
}
.game-results .rowAvatars .avatar .badges .game-bar .bar .icon img {
  height: 100%;
}
.game-results .rowAvatars .avatar .badges .game-bar .bar .icon-text {
  font-size: 0.767rem;
  color: #003399;
}
.game-results .rowAvatars .avatar .badges .game-bar .bar:nth-child(4) {
  border-right: none;
}
.game-results .divider {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.7rem;
}
.game-results .divider .badge-title {
  color: #fff;
  font-size: 0.967rem;
  text-align: center;
  flex-basis: 40%;
  white-space: nowrap;
}
.game-results .divider .row {
  background-color: #fff;
  width: 35.583rem;
  height: 0.11rem; /* FF3.6-15 */ /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to right, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.4) 10%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.4) 90%, rgba(255, 255, 255, 0.1) 100%);
}
.game-results .container-fluid {
  width: 39rem;
  margin-right: auto;
  margin-left: auto;
}
.game-results .container-fluid .container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: rgba(0, 25, 113, 0.6);
  border-radius: 0.667rem 2.333rem 2.333rem 0.667rem;
  width: 12.667rem;
  min-height: 3rem;
}
.game-results .container-fluid .container .inner-text {
  margin-left: 0.667rem;
}
.game-results .container-fluid .container .inner-text .con-title {
  color: white;
  font-size: 0.7rem;
}
.game-results .container-fluid .container .inner-text .subtitle {
  color: #F5DB6D;
  font-size: 0.6rem;
}
.game-results .container-fluid .container .inner-box {
  display: flex;
}
.game-results .container-fluid .container .inner-box .lock-box {
  border-radius: 4.375rem;
  width: 2rem;
  height: 2rem;
  text-align: center;
  margin-right: 0.333rem;
  position: relative;
}
.game-results .container-fluid .container .inner-box .lock-box img {
  width: 2rem;
  height: 2rem;
  pointer-events: none;
}
.game-results .container-fluid .container .inner-box .lock-box .anime-icon {
  position: absolute;
  top: -60%;
  left: -73%;
  width: 5rem;
  height: 4.5rem;
}
.game-results .container-fluid .container .inner-box .mini-box {
  margin-left: -0.917rem;
  margin-top: -0.2rem;
  background-color: #fff;
  height: 0.933rem;
  width: 0.933rem;
  border-radius: 1.875rem;
  z-index: 5;
}
.game-results .container-fluid .container .inner-box .mini-box img {
  width: 0.933rem;
  height: 0.933rem;
  pointer-events: none;
}
.game-results .container-fluid .container .inner-box .mini-box.lock {
  background-color: transparent;
}
.game-results .end-game {
  text-align: center;
  margin-top: 0.3rem;
}
.game-results .end-game .play-btn {
  text-align: center;
  width: 14.333rem;
  height: 2.667rem;
  background-color: #F5DB6C !important;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  border-radius: 1.333rem;
  font-size: 1rem;
  font-weight: bold;
  color: #003399;
}
.game-results .sidebar {
  margin: auto;
}
.game-results .sidebar .rectangle {
  min-height: 15.042rem;
  background: rgba(51, 102, 204, 0.4);
  border-radius: 0.667rem 0 0 0.667rem;
  padding: 1.875rem 1rem 1.875rem 2rem;
}
.game-results .sidebar .rectangle .group .group-section {
  margin-bottom: 2.458rem;
  display: flex;
  flex-direction: column;
}
.game-results .sidebar .rectangle .group .group-section .group-title {
  line-height: 1.083rem;
  font-size: 0.9rem;
  font-weight: bold;
  color: #FFD924;
}
.game-results .sidebar .rectangle .group .group-section .group-text {
  line-height: 1rem;
  font-size: 0.9rem;
  font-weight: bold;
  color: #fff;
  margin-top: 0.917rem;
  text-decoration: underline;
}
.game-results .sidebar .rectangle .group .group-section:last-child {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/game/multiplayer-game-results/multiplayer-game-results.page.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,yBAAA;UAAA,iBAAA;AACF;AACE;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;AACJ;AAEE;EACE,YAAA;EACA,YAAA;AAAJ;AAEI;EACE,8BAAA;EACA,uBAAA;AAAN;AAGQ;EACE,cAAA;AADV;AAIQ;EACE,cAAA;AAFV;AAKQ;EACE,cAAA;AAHV;AAOM;EACE,cAAA;AALR;AAQM;EACE,cAAA;EACA,mBAAA;AANR;AASM;EACE,cAAA;AAPR;AAWI;EACE,mBAAA;EACA,eAAA;EACA,+BAAA;EACA,kBAAA;AATN;AAYQ;EACE,kBAAA;EACA,MAAA;EACA,2BAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,oBAAA;EACA,WAAA;AAVV;AAYU;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,oCAAA;EACA,8FAAA;AAVZ;AAYY;EACE,eAAA;EACA,oBAAA;AAVd;AAgBM;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AAdR;AAiBM;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;AAfR;AAiBQ;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;AAfV;AAkBQ;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,UAAA;AAhBV;AAmBQ;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,2HAAA;AAjBV;AAoBQ;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iCAAA;EACA,kDAAA;AAlBV;AAqBQ;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,8FAAA;EACA,aAAA;AAnBV;AAsBQ;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;EACA,kDAAA;EACA,aAAA;AApBV;AAwBM;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AAtBR;AAyBM;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAvBR;AA0BM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;EACA,aAAA;AAxBR;AA0BQ;EACE,gBAAA;EACA,gBAAA;EACA,mCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAxBV;AA0BU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gDAAA;EACA,aAAA;EACA,qBAAA;AAxBZ;AA0BY;EACE,eAAA;EACA,YAAA;EACA,oBAAA;AAxBd;AA0Bc;EACE,YAAA;AAxBhB;AA4BY;EACE,mBAAA;EACA,cAAA;AA1Bd;AA8BU;EACE,kBAAA;AA5BZ;AAmCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AAjCJ;AAmCI;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAjCN;AAoCI;EACE,sBAAA;EACA,gBAAA;EACA,eAAA,EACA,aAAA,EACA,4BAAA;EACA,2LAAA;AAlCN;AAsCE;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;AApCJ;AAsCI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iCAAA;EACA,kDAAA;EACA,gBAAA;EACA,gBAAA;AApCN;AAsCM;EACE,qBAAA;AApCR;AAsCQ;EACE,YAAA;EACA,iBAAA;AApCV;AAuCQ;EACE,cAAA;EACA,iBAAA;AArCV;AAyCM;EACE,aAAA;AAvCR;AAyCQ;EACE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AAvCV;AAyCU;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AAvCZ;AA0CU;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AAxCZ;AA4CQ;EACE,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;AA1CV;AA4CU;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AA1CZ;AA8CQ;EACE,6BAAA;AA5CV;AAkDE;EACE,kBAAA;EACA,kBAAA;AAhDJ;AAkDI;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,8FAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhDN;AAoDE;EACE,YAAA;AAlDJ;AAoDI;EACE,qBAAA;EACA,mCAAA;EACA,oCAAA;EACA,oCAAA;AAlDN;AAsDQ;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;AApDV;AAsDU;EACE,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AApDZ;AAuDU;EACE,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;EACA,0BAAA;AArDZ;AAyDQ;EACE,gBAAA;AAvDV","sourcesContent":["ion-content {\n  height: 100vh;\n  --background: transparent;\n}\n\n.game-results {\n  user-select: none;\n\n  .title {\n    margin-top: 0.3rem;\n    color: #fff;\n    font-size: 1.167rem;\n    font-weight: bold;\n    margin-bottom: 0.792rem;\n  }\n\n  .rowAvatars {\n    width: 39rem;\n    margin: auto;\n\n    .avatar.active {\n      border: 0.083rem solid #FBDB55;\n      border-radius: 0.667rem;\n\n      .box1 {\n        .image1 {\n          display: block;\n        }\n\n        .platform-glow-copy {\n          display: block;\n        }\n\n        .triangle-copy {\n          display: block;\n        }\n      }\n\n      .finalScoreText {\n        display: block;\n      }\n\n      .finalScoreNum {\n        padding-top: 0;\n        margin-top: -0.2rem;\n      }\n\n      .badges {\n        display: block;\n      }\n    }\n\n    .avatar {\n      min-width: 6.771rem;\n      height: 13.1rem;\n      margin: 1rem auto 0.958rem auto;\n      position: relative;\n\n      .icons {\n        .section {\n          position: absolute;\n          top: 0;\n          transform: translateY(-50%);\n          display: flex;\n          width: 100%;\n          justify-content: center;\n          margin-left: -0.2rem;\n          gap: 0.2rem;\n\n          .border-icon {\n            width: 1rem;\n            height: 1rem;\n            border-radius: 1.458rem;\n            background-color: #F5DB6C !important;\n            background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n\n            .icon {\n              padding: 0.1rem;\n              pointer-events: none;\n            }\n          }\n        }\n      }\n\n      .playerName {\n        margin-top: 0.4rem;\n        text-align: center;\n        font-size: 0.883rem;\n        font-weight: bold;\n        color: white;\n      }\n\n      .box1 {\n        position: relative;\n        top: 2.8rem;\n        left: 50%;\n        transform: translateX(-43%);\n        margin-top: 0.208rem;\n        height: 7.384rem;\n        width: 6.771rem;\n\n        .image1 {\n          position: relative;\n          top: -3rem;\n          left: -1.992rem;\n          height: 6.952rem;\n          width: 9.426rem;\n          display: none;\n          pointer-events: none;\n        }\n\n        .image2 {\n          position: absolute;\n          top: -3.1rem;\n          left: 0.2rem;\n          height: 6.384rem;\n          width: 4.75rem;\n          pointer-events: none;\n          z-index: 5;\n        }\n\n        .platform-glow {\n          position: absolute;\n          top: -1.026rem;\n          left: 1.15rem;\n          height: 4.036rem;\n          width: 3.458rem;\n          background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.4) 100%);\n        }\n\n        .triangle {\n          position: absolute;\n          top: 3.02rem;\n          left: 1.15rem;\n          border: 1.72rem solid transparent;\n          border-top: 1.05rem solid rgba(255, 255, 255, 0.4);\n        }\n\n        .platform-glow-copy {\n          position: absolute;\n          top: 0.5rem;\n          left: 1.6rem;\n          height: 2.458rem;\n          width: 2.555rem;\n          background: linear-gradient(180deg, rgba(249, 236, 177, 0) 0%, rgba(255, 255, 255, 0.55) 100%);\n          display: none;\n        }\n\n        .triangle-copy {\n          position: absolute;\n          top: 2.96rem;\n          left: 1.55rem;\n          border: 1.3rem solid transparent;\n          border-top: 0.7rem solid rgba(255, 255, 255, 0.55);\n          display: none;\n        }\n      }\n\n      .finalScoreText {\n        text-align: center;\n        margin-top: -0.6rem;\n        white-space: nowrap;\n        font-size: 0.967rem;\n        color: white;\n        display: none;\n      }\n\n      .finalScoreNum {\n        text-align: center;\n        font-weight: bold;\n        color: #F5DB6C;\n        height: 1.792rem;\n      }\n\n      .badges {\n        position: absolute;\n        top: 98%;\n        left: 50%;\n        transform: translateX(-50%);\n        margin-top: 1rem;\n        display: none;\n\n        .game-bar {\n          width: 10.333rem;\n          height: 1.708rem;\n          background: var(--color-light-blue);\n          border-radius: 5rem;\n          display: flex;\n          margin-top: -1.7rem;\n          margin-left: auto;\n          margin-right: auto;\n\n          .bar {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 2.58325rem;\n            border-right: 0.042rem solid rgba(0, 0, 0, 0.32);\n            gap: 0.167rem;\n            text-decoration: none;\n\n            .icon {\n              width: 1.083rem;\n              height: 1rem;\n              pointer-events: none;\n\n              img {\n                height: 100%;\n              }\n            }\n\n            .icon-text {\n              font-size: 0.767rem;\n              color: #003399;\n            }\n          }\n\n          .bar:nth-child(4) {\n            border-right: none;\n          }\n        }\n      }\n    }\n  }\n\n  .divider {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 0.7rem;\n\n    .badge-title {\n      color: #fff;\n      font-size: 0.967rem;\n      text-align: center;\n      flex-basis: 40%;\n      white-space: nowrap;\n    }\n\n    .row {\n      background-color: #fff;\n      width: 35.583rem;\n      height: 0.11rem;\n      background: -moz-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.98) 50%, rgba(255, 255, 255, 1) 51%, rgba(255, 255, 255, 0) 99%, rgba(255, 255, 255, 0) 100%); /* FF3.6-15 */\n      background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.98) 50%, rgba(255, 255, 255, 1) 51%, rgba(255, 255, 255, 0) 99%, rgba(255, 255, 255, 0) 100%); /* Chrome10-25,Safari5.1-6 */\n      background: linear-gradient(to right, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.4) 10%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.4) 90%, rgba(255, 255, 255, 0.1) 100%);\n    }\n  }\n\n  .container-fluid {\n    width: 39rem;\n    margin-right: auto;\n    margin-left: auto;\n\n    .container {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n      background: rgba(0, 25, 113, 0.6);\n      border-radius: 0.667rem 2.333rem 2.333rem 0.667rem;\n      width: 12.667rem;\n      min-height: 3rem;\n\n      .inner-text {\n        margin-left: 0.667rem;\n\n        .con-title {\n          color: white;\n          font-size: 0.7rem;\n        }\n\n        .subtitle {\n          color: #F5DB6D;\n          font-size: 0.6rem;\n        }\n      }\n\n      .inner-box {\n        display: flex;\n\n        .lock-box {\n          border-radius: 4.375rem;\n          width: 2rem;\n          height: 2rem;\n          text-align: center;\n          margin-right: 0.333rem;\n          position: relative;\n\n          img {\n            width: 2rem;\n            height: 2rem;\n            pointer-events: none;\n          }\n\n          .anime-icon {\n            position: absolute;\n            top: -60%;\n            left: -73%;\n            width: 5rem;\n            height: 4.5rem;\n          }\n        }\n\n        .mini-box {\n          margin-left: -0.917rem;\n          margin-top: -0.2rem;\n          background-color: #fff;\n          height: 0.933rem;\n          width: 0.933rem;\n          border-radius: 1.875rem;\n          z-index: 5;\n\n          img {\n            width: 0.933rem;\n            height: 0.933rem;\n            pointer-events: none;\n          }\n        }\n\n        .mini-box.lock {\n          background-color: transparent;\n        }\n      }\n    }\n  }\n\n  .end-game {\n    text-align: center;\n    margin-top: 0.3rem;\n\n    .play-btn {\n      text-align: center;\n      width: 14.333rem;\n      height: 2.667rem;\n      background-color: #F5DB6C !important;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);;\n      border-radius: 1.333rem;\n      font-size: 1rem;\n      font-weight: bold;\n      color: #003399;\n    }\n  }\n\n  .sidebar {\n    margin: auto;\n\n    .rectangle {\n      min-height: 15.042rem;\n      background: rgba(51, 102, 204, 0.4);\n      border-radius: 0.667rem 0 0 0.667rem;\n      padding: 1.875rem 1rem 1.875rem 2rem;\n\n      .group {\n\n        .group-section {\n          margin-bottom: 2.458rem;\n          display: flex;\n          flex-direction: column;\n\n          .group-title {\n            line-height: 1.083rem;\n            font-size: 0.9rem;\n            font-weight: bold;\n            color: #FFD924;\n          }\n\n          .group-text {\n            line-height: 1rem;\n            font-size: 0.9rem;\n            font-weight: bold;\n            color: #fff;\n            margin-top: 0.917rem;\n            text-decoration: underline;\n          }\n        }\n\n        .group-section:last-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
